import { render, staticRenderFns } from "./NejmList.vue?vue&type=template&id=4f47ba6b"
import script from "./NejmList.vue?vue&type=script&lang=js"
export * from "./NejmList.vue?vue&type=script&lang=js"
import style0 from "./NejmList.vue?vue&type=style&index=0&id=4f47ba6b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports